import {
  LIST_MEMBERSHIP,
  CAMPAIGN,
  MESSAGE_CHANNEL,
  MESSAGE_TYPE,
  USER_LIST_MEMBERSHIP,
  UNSUBSCRIBED_CHANNELS,
  UNSUBSCRIBED_MESSAGE_TYPES,
  UNSUBSCRIBED_CHANNEL,
  UNSUBSCRIBED_MESSAGE_TYPE,
  LIST_MEMBERSHIP_SINGLE,
  USER_LIST_MEMBERSHIP_SINGLE,
} from 'utils/fieldConstants';
import { BOOLEAN, LONG, STRING, DATE, CAMPAIGN_LABEL } from 'utils/fieldTypes';
import { ExternalValue } from 'modules/workflowNodeEditors/editorComponents/ResourceSelect/ResourceSelect.types';

import { Query } from '../../FilterInputsList.types';
import { FilterBooleanValueInput } from './FilterBooleanValueInput';
import { FilterListMembershipValueInput } from './FilterListMembershipValueInput';
import { FilterStringValueInput } from './FilterStringValueInput';
import { FilterDateValueInput } from './FilterDateValueInput';
import { FilterCampaignInput } from './FilterCampaignInput';
import { FilterMessageChannelInput } from './FilterMessageChannelInput';
import { FilterMessageTypeInput } from './FilterMessageTypeInput';

type FilterValueInputProps = {
  onChange: (value: string | ExternalValue) => void;
  value: string;
  query: Partial<Query>;
  id: string;
  hasError: boolean;
  isDisabled?: boolean;
  placeholder?: string;
};

export const FilterValueInput = ({ query, ...props }: FilterValueInputProps) => {
  // Field-specific value inputs
  switch (query.field) {
    case LIST_MEMBERSHIP_SINGLE: // Email-based projects
    case LIST_MEMBERSHIP: // Email-based projects
      return <FilterListMembershipValueInput {...props} />;
    case USER_LIST_MEMBERSHIP_SINGLE: // UUID-based projects;
    case USER_LIST_MEMBERSHIP: // UUID-based projects
      return <FilterListMembershipValueInput {...props} />;
    case CAMPAIGN:
      return <FilterCampaignInput {...props} />;
    case MESSAGE_CHANNEL:
    case UNSUBSCRIBED_CHANNEL:
    case UNSUBSCRIBED_CHANNELS:
      return <FilterMessageChannelInput {...props} />;
    case MESSAGE_TYPE:
    case UNSUBSCRIBED_MESSAGE_TYPES:
    case UNSUBSCRIBED_MESSAGE_TYPE:
      return <FilterMessageTypeInput {...props} />;

    default:
    // Fall back to type-specific value inputs
  }

  // Type-specific value inputs
  switch (query.fieldType) {
    case STRING:
    case LONG:
    case CAMPAIGN_LABEL:
      return <FilterStringValueInput {...props} />;
    case BOOLEAN:
      return <FilterBooleanValueInput {...props} />;
    case DATE:
      return <FilterDateValueInput {...props} />;
    default:
      return <FilterStringValueInput {...props} />;
  }
};
